<template>
  <div class="header_container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item v-for="(item, index) in $route.meta" :key="index">{{item}}</el-breadcrumb-item>
    </el-breadcrumb>
    <a class="upercode" @click="dialogVisible=true">修改密码</a>
    <a class="wxCode" @click="getNotice">获取通知</a>
    <el-dropdown @command="handleCommand" menu-align="start">
      <img src="../assets/logo.png" class="avator" />
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="signout">退出</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown> 
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false">
      <el-input style="margin-bottom:10px" disabled v-model="phone" placeholder="请输入手机号">
        <template slot="append">
          <el-button v-show="codeshow" @click="getCode">获取验证码</el-button>
          <el-button v-show="!codeshow">{{count}} s</el-button>
        </template>
      </el-input>
      <el-input style="margin-bottom:10px" v-model="code" placeholder="请输入验证码"></el-input>
      <el-input style="margin-bottom:10px" v-model="password" show-password placeholder="请输入新密码"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="upercode()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="扫码绑定 获取通知"
      :visible.sync="dialogVisible2"
      width="20%"
      :close-on-click-modal="false"
    >
      <img style="width:200px;height:200px" :src="code" />
      <div>第一次扫码关注，第二次扫码微信公众号提示“用户名XXX绑定成功”，即绑定成功</div>
    </el-dialog>
  </div>
</template>

<script>
import myAxios from "../myAxios";
import {
    Message
} from 'element-ui'
export default {
  data() {
    return {
      username: localStorage.getItem("username"),
      dialogVisible: false,
      dialogVisible2: false,
      password: "",
      phone: "",
      code: "",
      codeshow: true,
      count: "",
      timer: null,
      code: ""
    };
  },
  created() {
     this.getPersonal();
  },
  computed: {},
  methods: {
    getPersonal() {
      var that=this
      myAxios
        .get(`client_user/Personal/v1?username=${this.username}`)
        .then(res => {
          this.phone = res.data.phone;
        }).catch(function(e){
          // that.$router.push("./Login")
          Message({
              message: "登录信息失效，请重新登录",
              type: 'error',
              duration: 5 * 1000
          });
        });
    },
    async handleCommand(command) {
      if (command == "signout") {
        localStorage.clear();
        this.$router.replace("/");
      }
    },
    getNotice() {
      this.dialogVisible2 = true;
      this.code = localStorage.getItem("wxCode");
    },
    getCode() {
      var that = this;
      myAxios
        .get(`/client_login/GetSmsCode/v1?phone=${this.phone}`)
        .then(res => {
          if (res.code == 0) {
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.codeshow = false;
              this.phone = "";
              this.code = "";
              this.password = "";
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.codeshow = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
          } else {
            this.$notify.error({
              title: "错误",
              message: res.message,
              offset: 100
            });
          }
        })
        .catch(function(error) {});
      const TIME_COUNT = 59;
    },
    upercode() {
      if (this.input == "" || this.input2 == "") {
      } else {
        myAxios
          .post(
            `/client_user/UpdatePassword/v1?username=${this.username}&password=${this.password}&code=${this.code}`
          )
          .then(res => {
            if (res.code == 0) {
              this.$alert(res.data, "提示", {
                confirmButtonText: "确定"
              }).then(() => {
                this.dialogVisible = false;
                this.changeData("", "", "", "");
              });
            } else {
              this.$alert(res.message, "提示", {
                confirmButtonText: "确定"
              });
            }
          });
        // client_user/UpdatePassword/v1?username=123&password=123&newPassword=123
      }
    }
  }
};
</script>

<style lang="less">
@import "../style/mixin";
.header_container {
  background-color: #eff2f7;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 20px;
}
.avator {
  .wh(36px, 36px);
  border-radius: 50%;
  margin-right: 37px;
}
.el-dropdown-menu__item {
  text-align: center;
}
.upercode {
  margin-left: 400px;
  font-size: 10pt;
  cursor: pointer;
  color: #6e6e6e;
}
.wxCode {
  margin-left: -150px;
  cursor: pointer;
  font-size: 10pt;
  color: #6e6e6e;
}
</style>
